import { IFormField } from "@/interfaces";

const INACTIVE_FIELD_STATUS = "Inactive";

export const getActiveField = (field: IFormField): IFormField | null => {
  if (field.property.status === INACTIVE_FIELD_STATUS) {
    return null;
  }

  if (field.children?.length) {
    const children = field.children
      .map((child) => getActiveField(child))
      .filter((child) => !!child) as IFormField[];

    return { ...field, children: [...children] };
  }

  return field;
};
